const CHECKOUT_CONST = {
    CHECKOUT_INITIALIZE: "INITIALIZE_CHECKOUT_STEP",
    STEP_STATUS: "SET_CHECKOUT_STEP_STATUS",
    DELIVERY_ADDRESS_SELECTED: "DELIVERY_ADDRESS_SELECTED",
    DELIVERY_ADDRESS_CONFIRMED: "DELIVERY_ADDRESS_CONFIRMED",
    ITEMS_TO_CHECKOUT: "ADD_ITEMS_TO_CHECKOUT",
    REMOVE_ITEM: "REMOVE_ITEM_FROM_CHECKOUT",
    CHECKOUT_TERMINATE: "TERMINATE_CHECKOUT_STEP"
}

export default CHECKOUT_CONST;